import React, { useState, useEffect } from "react";
import {
  InputLabel,
  DialogTitle,
  Dialog,
  Box,
  Grid,
  Button,
  TextField,
  Typography,
  IconButton,
  Divider,
} from "@mui/material";
import { useTheme } from "@mui/material/styles"; // Import useTheme
// Removed: import { makeStyles } from "@mui/styles";
// Removed: import styled from "styled-components"; 

import { updateRecipe, saveCurrentRecipe } from "../actions/recipes";
import { useDispatch } from "react-redux";
import moment from "moment";
import { Close } from "@mui/icons-material";

// Note: No more useStyles definition needed

function EditRecipe(props) {
  const { onClose, open, currentRecipe } = props;
  const dispatch = useDispatch();
  const theme = useTheme(); // Access the theme for spacing and colors

  // Initialize state with currentRecipe values
  const [title, setTitle] = useState(currentRecipe.title || "");
  const [description, setDescription] = useState(currentRecipe.description || "");
  const [servings, setServings] = useState(currentRecipe.servings || "");
  const [prepTime, setPrepTime] = useState(currentRecipe.prepTime || "");
  const [cookTime, setCookTime] = useState(currentRecipe.cookTime || "");
  const [image, setImage] = useState(currentRecipe.images?.medium || "");

  // --- useEffect to update state when currentRecipe prop changes ---
  useEffect(() => {
    // Only update if the dialog is open and a recipe is passed
    if (currentRecipe) {
      setTitle(currentRecipe.title || "");
      setDescription(currentRecipe.description || "");
      setServings(currentRecipe.servings || "");
      setPrepTime(currentRecipe.prepTime || "");
      setCookTime(currentRecipe.cookTime || "");
      setImage(currentRecipe.images?.medium || "");
    }
  }, [currentRecipe]);

  // --- Handlers ---
  const handleClose = () => onClose();
  const handleTitleChange = (e) => setTitle(e.target.value);
  const handleDescriptionChange = (e) => setDescription(e.target.value);
  const handleServingsChange = (e) => setServings(e.target.value);
  const handlePrepTimeChange = (e) => setPrepTime(e.target.value);
  const handleCookTimeChange = (e) => setCookTime(e.target.value);
  const handleImageChange = (e) => setImage(e.target.value);

  // --- Submission Logic ---
  function editItem() {
    const dateAndTime = moment().format("L LTS");

    const newRecipe = {
      uuid: currentRecipe.uuid,
      title: title,
      description: description,
      servings: servings,
      prepTime: prepTime,
      cookTime: cookTime,
      postDate: currentRecipe.postDate,
      editDate: dateAndTime,
      directions: currentRecipe.directions,
      ingredients: currentRecipe.ingredients,
      images: image ? { medium: image } : null,
    };

    dispatch(updateRecipe(newRecipe));
    dispatch(saveCurrentRecipe());

    handleClose();
  }

  // Define shared styles using sx prop syntax for consistency
  const closeButtonStyle = {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  };
  const inputStyle = { mb: 2 };
  
  return (
    <Dialog
      maxWidth={"sm"}
      fullWidth={true}
      onClose={handleClose}
      aria-labelledby="edit-recipe"
      open={open}
    >
      <DialogTitle
        id="edit-recipe"
        sx={{
          borderBottom: `1px solid ${theme.palette.divider}`,
          padding: theme.spacing(2, 3),
        }}
      >
        <Typography variant="h5" component="span" sx={{ fontWeight: 600 }}>
          📝 Edit Recipe: {currentRecipe.title}
        </Typography>
        <IconButton aria-label="close" sx={closeButtonStyle} onClick={handleClose}>
          <Close />
        </IconButton>
      </DialogTitle>

      <Box component="form" noValidate autoComplete="off" sx={{ p: 4 }}>
        <Grid container spacing={4}>
          {/* --- Column 1: Core Details --- */}
          <Grid item xs={12}>
            <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
                Basic Information
            </Typography>
            <Divider sx={{ mb: 2 }} />

            <TextField
              fullWidth
              label="Recipe Title"
              placeholder="Enter a new name"
              onChange={handleTitleChange}
              value={title}
              sx={inputStyle}
            />

            {/* Using TextField with multiline for a better-looking description input */}
            <TextField
              fullWidth
              label="Description"
              placeholder="Enter a description"
              multiline
              rows={4}
              onChange={handleDescriptionChange}
              value={description}
              sx={inputStyle}
            />

            <InputLabel htmlFor="image" sx={{ mb: 1, color: 'text.secondary', typography: 'caption' }}>
              Image URL
            </InputLabel>
            <TextField
              fullWidth
              id="image"
              placeholder="Enter Image Url"
              onChange={handleImageChange}
              value={image}
              sx={inputStyle}
            />
          </Grid>

          {/* --- Column 2: Time and Servings --- */}
          <Grid item xs={12}>
            <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
                Time & Quantity
            </Typography>
            <Divider sx={{ mb: 2 }} />
            
            <TextField
              fullWidth
              label="Servings"
              type="number"
              placeholder="Enter the amount of servings"
              onChange={handleServingsChange}
              value={servings}
              sx={inputStyle}
            />

            <TextField
              fullWidth
              label="Prep Time (in mins)"
              type="number"
              placeholder="Enter the prep time"
              onChange={handlePrepTimeChange}
              value={prepTime}
              sx={inputStyle}
            />

            <TextField
              fullWidth
              label="Cook Time (in mins)"
              type="number"
              placeholder="Enter the cook time"
              onChange={handleCookTimeChange}
              value={cookTime}
              sx={inputStyle}
            />
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ p: 3, display: 'flex', justifyContent: 'center', borderTop: `1px solid ${theme.palette.divider}` }}>
        <Button
          onClick={editItem}
          size="large"
          variant="contained"
          color="primary"
          sx={{ padding: theme.spacing(1, 4), fontSize: '1.1rem' }}
        >
          Finished Editing
        </Button>
      </Box>
    </Dialog>
  );
}
export default EditRecipe;